'use client';

import { useField } from 'formik';
import { FC, useState } from 'react';
import * as yup from 'yup';

import { InputFormikProps } from './Input.type';
import { InputEmail } from './InputEmail';
import { validateEmail } from 'src/services/AuthService';

const emailSchema = yup.string().email();

/**
 * InputEmailFormik field expected to be used within a Formik context
 */
export const InputEmailFormik: FC<Omit<InputFormikProps<typeof InputEmail>, 'validateSchema'>> = (props) => {
  const [pending, setPending] = useState(false);
  const [field, meta, helpers] = useField<string>({
    name: props.name,
    validate: async (email) => {
      if (!props.showClientError) {
        return undefined;
      }
      setPending(true);
      try {
        const { block } = await validateEmail(email, { apiKey: process.env.BFF_API_KEY });

        setPending(false);
        return block ? 'Please enter valid email address' : undefined;
      } catch (error) {
        // skip validation if there is an error
        setPending(false);
        return undefined;
      }
    },
  });

  const validateSchema = (value: string) => {
    const isValid = emailSchema.isValidSync(value);
    return { success: isValid };
  };

  return (
    <InputEmail
      {...props}
      value={field.value}
      error={meta.error && meta.touched ? meta.error : undefined}
      onChange={(value) => helpers.setValue(value)}
      validateSchema={validateSchema}
      pending={pending}
    />
  );
};
